import React from 'react';

type IAllocationIcon = {
  size?: string;
  className?: string;
};

const AllocationIcon: React.FC<IAllocationIcon> = props => {
  const { size = '28', className } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none">
      <path
        fill="#FFF5E8"
        d="M14 26c6.6274 0 12-5.3726 12-12 0-6.62742-5.3726-12-12-12C7.37258 2 2 7.37258 2 14c0 6.6274 5.37258 12 12 12Z"
      />
      <path
        fill="#F98600"
        d="M19.001 10.1647v6.7231c0 .5004-.4102.9098-.9116.9098H12.31c-.5014 0-.9116-.4094-.9116-.9098V8.60898c0-.50037.4102-.90976.9116-.90976h4.3482c.2553 0 .5014.10917.6746.29112l1.4312 1.5557c.1549.16376.237.3912.237.61866Z"
      />
      <path
        stroke="#F98600"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M15.1076 20.0631H9.91158c-.50137 0-.91158-.4094-.91158-.9098v-7.8877"
      />
    </svg>
  );
};

export default AllocationIcon;
